



































































































































































































































































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount, ref, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue"
import TextEditBox from "../../components/TextEditBox.vue"
import DrawArea from "../../components/DrawArea.vue";
import { BModal } from 'bootstrap-vue';
// @ts-ignore
import VueDragResize from "vue-drag-resize";
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 600, interval: 0})
import { BaseSheet, AutoReviewTextTemplate, AutoReviewImageTemplate, AutoReviewImageBookmark, PageItem, ParamAutoReviewTextTemplate, ParamAutoReviewImageTemplate, SearchCondition, TemplateTypeEnum, AutoReviewTargetTypeEnum, Part1Option }from  "../../modules/teacher/AutoReviewTemplateEdit"
import heic2any from "heic2any";

export interface Data {
  tabNo: number
  base_sheet_id: string
  baseSheet: BaseSheet | null
  pageItems: PageItem[]
  currentPage: number
  currentReviewTemplate: any
  errors: string[]
  fontSize: number
  lineHeight: number
  textColor: string
  inputScale: number
  isDragging: boolean
  isStampTouching: boolean
  isDispSingle: boolean
  condition: SearchCondition
  baseSheets: BaseSheet[]
  fields: any[]
  helpFields: any[]
  keyCode: string
  point: Common.Point
  baseDistance: number
  baseScale: number
  pinchOffsetX: number
  pinchOffsetY: number
  pinchMarginX: number
  pinchMarginY: number
  touchLength: number
  isAllSelectChecked: boolean
  autoReviewImageBookmarks: AutoReviewImageBookmark[]
  part1Options: Part1Option[]
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "text-edit-box": TextEditBox,
    "text-direction-toggle": TextDirectionToggle,
    "vue-drag-resize": VueDragResize,
    "draw-area": DrawArea,
  },
  setup(props, context){

    const textEditBoxRef = ref<InstanceType<typeof TextEditBox>>();
    const modalBaseSheetListRef = ref<InstanceType<typeof BModal>>();
    const modalImageBookmarkRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
      * data
      ************************************************************/

    const state = reactive<Data>({
      tabNo: 7,
      base_sheet_id: "",
      baseSheet: null,
      pageItems: [],
      currentPage: 1,
      currentReviewTemplate: null,
      errors: [],
      fontSize: 48,
      lineHeight: 0,
      textColor: "#FF0000",
      inputScale: 50,
      isDragging: false,
      isStampTouching: false,
      isDispSingle: false,
      condition: new SearchCondition(),
      baseSheets: [],
      fields: [
        {key: "sheet_code", label: "レポートID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "report_no", label: "レポートNo", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "copy", label: "コピー", class: 'text-center b-table-th-td'},
      ],
      helpFields: [
        { key: "上矢印キー", img: require("@/assets/images/keyboard_Arrow_Up.png"), description: "前の講評に移動" },
        { key: "下矢印キー", img: require("@/assets/images/keyboard_Arrow_Down.png"), description: "次の講評に移動" },
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "講評出力" },
        { key: "講評選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "講評削除" },
        { key: "解答用紙上でCtrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "解答用紙の拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        { key: "解答用紙上でピンチイン・ピンチアウト", description: "解答用紙の拡大縮小" },
        { key: "解答用紙を長押し", description: "長押しした場所に講評を出力" },
        { key: "講評を長押し", description: "長押しした講評を削除" },
      ],
      keyCode: null,
      point: null,
      baseScale : 0,
      baseDistance: 0,
      pinchOffsetX: 0,
      pinchOffsetY: 0,
      pinchMarginX: 0,
      pinchMarginY: 0,
      touchLength: 0,
      isAllSelectChecked: true,
      autoReviewImageBookmarks: [],
      part1Options: [],
    });

    /****************************************
      * 倍率を加味した画像の横幅
      ****************************************/

      const scale = computed(() => {
      return state.inputScale / 100;
    });

    /****************************************
      * 倍率を加味した画像の横幅
      ****************************************/

      const parentW = computed(() => {
      return currentPageItem.value ? currentPageItem.value.baseWidth * scale.value : 0;
    });

    /****************************************
      * 倍率を加味した画像の横幅
      ****************************************/

    const parentH = computed(() => {
      return currentPageItem.value ? currentPageItem.value.baseHeight * scale.value : 0;
    });

    /****************************************
      * 画像のサイズCSSスタイル
      ****************************************/

      const imageWrapStyle = computed(() => {
      let style: any = {};
      style["width"] = `${parentW.value}px`;
      style["height"] = `${parentH.value}px`;
      return style;
    });

    /****************************************
      * 画面サイズに合わせてレイアウト整形
      ****************************************/

      const adjustHeight = () => {
      context.root.$nextTick(() => {
        const winH = window.innerHeight;
        const tableArea = document.getElementById("table-area");
        const imageArea = document.getElementById("image-area");

        if(tableArea != null && imageArea != null){
          tableArea.style.height = (winH - tableArea.offsetTop) + "px";
          imageArea.style.height = (winH - imageArea.offsetTop) + "px";
        }
      });
    };

    /************************************************************
      * 対象プルダウン選択肢
      ************************************************************/

    const reviewTargetOptions = computed((): any[] => {
      // 合計点に加え、現在存在する大問を単一プルダウンの選択肢として並べる
      return [{ value: "total", text: "合計点" }].concat(state.part1Options.map((x: Part1Option) => ({ value: `part1:${x.value}`, text: x.text })));
    });

    /************************************************************
      * 全ページ分の講評テンプレート
      ************************************************************/

    const allReviewTemplates = computed((): any[] => {
      let rtn: any[] = [];
      state.pageItems.forEach(x => rtn = rtn.concat(x.autoReviewTextTemplates));
      state.pageItems.forEach(x => rtn = rtn.concat(x.autoReviewImageTemplates));
      return rtn.sort((a: any, b: any) => compareReviewTemplate(a, b));
    });

    /************************************************************
      * 全ページ分のテキストテンプレート
      ************************************************************/

    const allReviewTextTemplates = computed((): any[] => {
      let rtn: any[] = [];
      state.pageItems.forEach(x => rtn = rtn.concat(x.autoReviewTextTemplates));
      return rtn;
    });

    /************************************************************
      * 全ページ分の画像テンプレート
      ************************************************************/

    const allReviewImageTemplates = computed((): any[] => {
      let rtn: any[] = [];
      state.pageItems.forEach(x => rtn = rtn.concat(x.autoReviewImageTemplates));
      return rtn;
    });

    /************************************************************
      * 現在表示中のPageItem
      ************************************************************/

      const currentPageItem = computed((): PageItem => {
      return state.pageItems.find(x => x.page == state.currentPage);
    });

    /************************************************************
      * 選択中のテキスト要素のID
      ************************************************************/

    const currentReviewTextElemId = computed((): any => {
      return state.currentReviewTemplate ? `page-${currentPageItem.value.page}-${state.currentReviewTemplate.idx}-text-stamp` : null;
    });

    const compareReviewTemplate = (template1: any, template2: any): number => {
      // 一覧は 合計点→大問、part1昇順、コメント→画像、得点範囲降順 の順で表示
      const targetSort1 = template1.target_type == AutoReviewTargetTypeEnum.TotalScore ? 0 : 1;
      const targetSort2 = template2.target_type == AutoReviewTargetTypeEnum.TotalScore ? 0 : 1;
      if(targetSort1 != targetSort2){
        return targetSort1 - targetSort2;
      }

      const part1Value1 = template1.part1 ?? "";
      const part1Value2 = template2.part1 ?? "";
      if(part1Value1 != part1Value2){
        return part1Value1.localeCompare(part1Value2, undefined, {numeric: true});
      }

      const templateTypeSort1 = template1.template_type == TemplateTypeEnum.Text ? 0 : 1;
      const templateTypeSort2 = template2.template_type == TemplateTypeEnum.Text ? 0 : 1;
      if(templateTypeSort1 != templateTypeSort2){
        return templateTypeSort1 - templateTypeSort2;
      }

      const scoreFrom1 = template1.score_from ?? Number.MIN_SAFE_INTEGER;
      const scoreFrom2 = template2.score_from ?? Number.MIN_SAFE_INTEGER;
      if(scoreFrom1 != scoreFrom2){
        return scoreFrom2 - scoreFrom1;
      }

      return template1.idx - template2.idx;
    };

    const getReviewTargetValue = (reviewTemplate: any): string => {
      // 内部保持している target_type / part1 をプルダウン値へ変換
      if(reviewTemplate.target_type == AutoReviewTargetTypeEnum.Part1 && reviewTemplate.part1 != null){
        return `part1:${reviewTemplate.part1}`;
      }
      return "total";
    };

    const changeReviewTarget = (reviewTemplate: any, targetValue: string) => {
      // 単一プルダウンの選択値を保存用の target_type / part1 へ変換
      if(targetValue == "total"){
        reviewTemplate.target_type = AutoReviewTargetTypeEnum.TotalScore;
        reviewTemplate.part1 = null;
      }else{
        reviewTemplate.target_type = AutoReviewTargetTypeEnum.Part1;
        reviewTemplate.part1 = targetValue.replace("part1:", "");
      }
      reviewTemplate.is_edited = true;
    };

    /****************************************
      * 一覧の行クリック
      ****************************************/
    
      const trClick = async (reviewTemplate: any) => {
      changeCurrentReviewTemplate(reviewTemplate);
      context.root.$nextTick(async () => {
        if(reviewTemplate && reviewTemplate.is_disp){
          await scrollImageArea(currentReviewTextElemId.value);
          scrollTableArea(`tr-${reviewTemplate.page}-${reviewTemplate.idx}`);

          if(reviewTemplate.template_type == TemplateTypeEnum.Text){
            textEditBoxRef.value.moveTextEditbox();
          }
        }
      });
    };

    /****************************************
      * 一覧スクロール
      ****************************************/

      const scrollTableArea = (trId: string) => {
      if(!trId){
        return;
      }
      const scrollArea = document.getElementById("table-area");
      const trArea = document.getElementById(trId);

      if(!trArea){
        return;
      }

      const scrollAreaHeight = scrollArea.offsetHeight;
      const scrollAreaTop = scrollArea.scrollTop;
      const scrollAreaBottom = scrollAreaTop + scrollAreaHeight;
      const trTop = trArea.offsetTop;
      const trBottom = trArea.offsetTop + trArea.offsetHeight;

      if(scrollAreaTop > trTop){
        scrollArea.scrollTop -= trArea.offsetHeight;
      }else if(scrollAreaBottom < trBottom){
        scrollArea.scrollTop += trArea.offsetHeight;
      }
    }

    /****************************************
      * 枠までスクロール
      ****************************************/

    const scrollImageArea = async (rectId: string) => {
      const rectElement = document.getElementById(rectId);
      const imageArea = document.getElementById("image-area");

      if(!rectElement){
        return;
      }

      const imageAreaWidth = imageArea.offsetWidth;
      const imageAreaHeight = imageArea.offsetHeight;
      const imageAreaTop = imageArea.scrollTop;
      const imageAreaBottom = imageAreaTop + imageAreaHeight;
      const imageAreaLeft = imageArea.scrollLeft;
      const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
      const rectTop = rectElement.offsetTop;
      const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
      const rectLeft = rectElement.offsetLeft;
      const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

      let fromTop = imageAreaTop;
      let toTop = imageAreaTop;
      let fromLeft = imageAreaLeft;
      let toLeft = imageAreaLeft;

      if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
        toTop = rectTop - (imageAreaHeight / 3);
      }

      if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
        toLeft = rectLeft - (imageAreaWidth / 3);
      }

      if(fromTop != toTop || fromLeft != toLeft){
        await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
      }
    }

    /************************************************************
      * 画像上をtouchstart
      ************************************************************/

      const imageAreaTouchstart = (e: TouchEvent) => {
      state.touchLength = e.touches.length;
    }

    /************************************************************
      * 画像上をtouchend
      ************************************************************/

      const imageAreaTouchend = (e: TouchEvent) => {
      state.baseDistance = 0;
      state.touchLength = e.touches.length;
    }

    /************************************************************
      * ピンチによる拡大縮小
      ************************************************************/

    const imageAreaTouchmove = (e: TouchEvent) => {

      state.touchLength = e.touches.length;

      if(e.touches.length > 1){
        
        e.preventDefault();

        const touches = e.touches;

        const x1 = touches[0].screenX;
        const y1 = touches[0].screenY;

        const x2 = touches[1].screenX;
        const y2 = touches[1].screenY;

        const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        
        if(state.baseDistance){
          const addScale = distance - state.baseDistance;
          
          // 値が低いほど早く拡大縮小する
          const pinchSpeed = 3;

          const newScale = state.baseScale + addScale / pinchSpeed;
          
          if(newScale >= 10 && newScale <= 200){
            state.inputScale = newScale;

            const offsetX = state.pinchOffsetX * scale.value;
            const offsetY = state.pinchOffsetY * scale.value;

            const pageRoot = document.getElementById(`image-area`);
            pageRoot.scrollLeft = offsetX - state.pinchMarginX;
            pageRoot.scrollTop = offsetY - state.pinchMarginY;
          }
          
        }else{
          state.baseDistance = distance;
          state.baseScale  = Number(state.inputScale);
          
          const offsetXs = [];
          const offsetYs = [];

          for(let i = 0; i < 2; i++){
            const touch = e.touches[i];
            const touchElement = touch.target as HTMLElement;
            const bounds = touchElement.getBoundingClientRect();
            offsetXs.push(touch.clientX - window.pageXOffset - bounds.left) 
            offsetYs.push(touch.clientY - window.pageYOffset - bounds.top)
          }

          // 解答用紙原寸大換算のピンチ中心座標取得
          const offsetX1 = offsetXs[0] > offsetXs[1] ? offsetXs[1] : offsetXs[0];
          const offsetX2 = offsetXs[0] > offsetXs[1] ? offsetXs[0] : offsetXs[1];
          const offsetY1 = offsetYs[0] > offsetYs[1] ? offsetYs[1] : offsetYs[0];
          const offsetY2 = offsetYs[0] > offsetYs[1] ? offsetYs[0] : offsetYs[1];
          const offsetX = offsetX1 + ((offsetX2 - offsetX1) / 2);
          const offsetY = offsetY1 + ((offsetY2 - offsetY1) / 2);
          state.pinchOffsetX = offsetX / scale.value;
          state.pinchOffsetY = offsetY / scale.value;

          const rootDiv = document.getElementById(`image-area`);
          state.pinchMarginX = offsetX - rootDiv.scrollLeft;
          state.pinchMarginY = offsetY - rootDiv.scrollTop;
        }
      }
    }

    /******************************
      * 倍率スライダー
      ******************************/

    watch(() => state.inputScale, (newVal, oldVal) => {

      if(state.touchLength == 0){
        const pageRoot = document.getElementById(`image-area`);
        const baseOffsetX = (pageRoot.scrollLeft + (pageRoot.offsetWidth / 2)) / (oldVal / 100);
        const baseOffsetY = (pageRoot.scrollTop + (pageRoot.offsetHeight / 2)) / (oldVal / 100);
        const centerX = pageRoot.offsetWidth / 2;
        const centerY = pageRoot.offsetHeight / 2;

        const newOffsetX = baseOffsetX * (Number(newVal) / 100);
        const newOffsetY = baseOffsetY * (Number(newVal) / 100);

        pageRoot.scrollLeft = newOffsetX - centerX;
        pageRoot.scrollTop = newOffsetY - centerY;
      }
    });

    /******************************
      * マウスホイール拡大縮小
      ******************************/

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(state.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    /****************************************
      * 選択中のテンプレート切り替え
      ****************************************/

    const changeCurrentReviewTemplate = (reviewTemplate: any) => {
      if(reviewTemplate){
        state.currentPage = reviewTemplate.page;
      }
      state.currentReviewTemplate = reviewTemplate;
      if(reviewTemplate && reviewTemplate instanceof AutoReviewTextTemplate){
        state.fontSize = reviewTemplate.font_size;
        state.lineHeight = reviewTemplate.line_height;
        state.textColor = reviewTemplate.color;
      }
    }

    /************************************************************
      * テキストテンプレート追加
      ************************************************************/

    const addReviewTextTemplate = (param: any) => {
      const size = Common.getTextSize({text: "", fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection});
      const autoReviewTextTemplate = new AutoReviewTextTemplate();
      autoReviewTextTemplate.page = state.currentPage;
      autoReviewTextTemplate.target_type = AutoReviewTargetTypeEnum.TotalScore;
      autoReviewTextTemplate.part1 = null;
      autoReviewTextTemplate.text = "";
      autoReviewTextTemplate.idx = currentPageItem.value.templateIdx++;
      autoReviewTextTemplate.font_size = state.fontSize;
      autoReviewTextTemplate.line_height = state.lineHeight;
      autoReviewTextTemplate.color = state.textColor;
      autoReviewTextTemplate.x = param.point.x;
      autoReviewTextTemplate.y = param.point.y;
      autoReviewTextTemplate.width = size.width;
      autoReviewTextTemplate.height = size.height;
      autoReviewTextTemplate.direction = context.root.$store.state.textDirection;
      autoReviewTextTemplate.is_edited = true;
      autoReviewTextTemplate.base64_text = Common.createBase64Text(autoReviewTextTemplate);
      autoReviewTextTemplate.template_type = TemplateTypeEnum.Text;
      currentPageItem.value.autoReviewTextTemplates.push(autoReviewTextTemplate);
      state.currentReviewTemplate = autoReviewTextTemplate;
      changeCurrentReviewTemplate(autoReviewTextTemplate);
    }

    /************************************************************
    * 画像テンプレート追加
    ************************************************************/

    const addReviewImageTemplate = (autoReviewImageBookmark: AutoReviewImageBookmark) => {
      let imageScale = 1;
      
      if(autoReviewImageBookmark.width > currentPageItem.value.baseWidth - 20 || autoReviewImageBookmark.height > currentPageItem.value.baseHeight - 20){
        const scaleW = (currentPageItem.value.baseWidth - 20) / autoReviewImageBookmark.width;
        const scaleH = (currentPageItem.value.baseHeight - 20) / autoReviewImageBookmark.height;

        if(scaleW > scaleH){
          imageScale = scaleH;
        }else{
          imageScale = scaleW
        }
      }

      const imageArea = document.getElementById("image-area");

      const autoReviewImageTemplate = new AutoReviewImageTemplate();
      autoReviewImageTemplate.page = state.currentPage;
      autoReviewImageTemplate.target_type = AutoReviewTargetTypeEnum.TotalScore;
      autoReviewImageTemplate.part1 = null;
      autoReviewImageTemplate.idx = currentPageItem.value.templateIdx++;
      autoReviewImageTemplate.x = (imageArea.scrollLeft + 10) / scale.value;
      autoReviewImageTemplate.y = (imageArea.scrollTop + 10) / scale.value;
      autoReviewImageTemplate.width = autoReviewImageBookmark.width * imageScale;
      autoReviewImageTemplate.height = autoReviewImageBookmark.height * imageScale;
      autoReviewImageTemplate.base64_image = autoReviewImageBookmark.base64_image;
      autoReviewImageTemplate.template_type = TemplateTypeEnum.Image;
      currentPageItem.value.autoReviewImageTemplates.push(autoReviewImageTemplate);
      changeCurrentReviewTemplate(autoReviewImageTemplate);

      modalImageBookmarkRef.value.hide();
    }

    /************************************************************
    * 画像ブックマーク追加
    ************************************************************/
    const addReviewImageBookmark = (event: any) => {

      const files = event.target.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      const extentions = ["jpg", "jpeg", "heic", "png"];
      const file_work = files[0].name.split('.');
      const extention = file_work[file_work.length - 1].toLowerCase();
      if(!extentions.includes(extention)) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      if(extention == "heic"){
        heic2any({
          blob: files[0],
          toType: 'image/jpeg',
          quality: 1.0
        })
        .then((conversionResult: any) => {
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = URL.createObjectURL(conversionResult);
        })
        .catch(function(error) {
          console.error(error);
        });
      }else{
        const reader  = new FileReader();
        reader.onload = (e) => {        
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = e.target?.result as string;
        };
        reader.readAsDataURL(files[0]);
      }

      event.target.value = "";
    };

    /************************************************************
    * 画像ファイルロード後
    ************************************************************/

    const imageLoaded = async (img: HTMLImageElement, extention: string) => {
      const imageType = extention == "png" ? "image/png" : "image/jpeg"
      let width = img.width;
      let height = img.height;

      // 画像をcanvasに描画した後にbase64文字列に変換
      const canvas = document.createElement("canvas") as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      const base64_image = canvas.toDataURL(imageType, 1.0).replace(`data:${imageType};base64,`, "");

      const param = {
        width: width,
        height: height,
        base64_image: base64_image,
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/auto_review_template_edit/entry_image_bookmark`, param).then(response => {
        Common.showToast(context.root.$bvToast, "画像を追加しました。");
        state.autoReviewImageBookmarks= response.data.auto_review_image_bookmarks.map((x: any) => new AutoReviewImageBookmark(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
    * テキストテンプレート削除
    ************************************************************/

    const deleteReviewTextTemplate = (reviewTemplate: AutoReviewTextTemplate) => {
      const pageItem = state.pageItems.find(x => x.autoReviewTextTemplates.includes(reviewTemplate));
      const idx = pageItem.autoReviewTextTemplates.indexOf(reviewTemplate);
      pageItem.autoReviewTextTemplates.splice(idx, 1);
      state.currentReviewTemplate = null;
    }

    /************************************************************
    * 画像テンプレート削除
    ************************************************************/

    const deleteReviewImageTemplate = (reviewTemplate: AutoReviewImageTemplate) => {
      const pageItem = state.pageItems.find(x => x.autoReviewImageTemplates.includes(reviewTemplate));
      const idx = pageItem.autoReviewImageTemplates.indexOf(reviewTemplate);
      pageItem.autoReviewImageTemplates.splice(idx, 1);
      state.currentReviewTemplate = null;
    }

    /************************************************************
    * 画像ブックマーク削除
    ************************************************************/

    const deleteReviewImageBookmark = async (autoReviewImageBookmark: AutoReviewImageBookmark) => {

      if(!window.confirm("画像を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/auto_review_template_edit/destroy_image_bookmark`, {id: autoReviewImageBookmark.id}).then(response => {
        Common.showToast(context.root.$bvToast, "画像を削除しました。");
        state.autoReviewImageBookmarks= response.data.auto_review_image_bookmarks.map((x: any) => new AutoReviewImageBookmark(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }
  
    /************************************************************
    * テンプレート 座標更新
    ************************************************************/

    const setReviewTemplatePosition = (reviewTemplate: any, rect: any) => {

      let x = 0;
      let y = 0;

      if(rect.left < 0){
        x = reviewTemplate.x == 1 ? 0 : 1;
      }else if(rect.left + rect.width > currentPageItem.value.baseWidth * scale.value){
        const limitX = ((currentPageItem.value.baseWidth * scale.value) - rect.width) / scale.value;
        x = reviewTemplate.x == limitX ? limitX - 1 : limitX;
      }else{
        x = rect.left / scale.value;
      }

      if(rect.top < 0){
        y = reviewTemplate.y == 1 ? 0 : 1;
      }else if(rect.top + rect.height > currentPageItem.value.baseHeight * scale.value){
        const limitY = ((currentPageItem.value.baseHeight * scale.value) - rect.height) / scale.value;
        y = reviewTemplate.y == limitY ? limitY - 1 : limitY;
      }else{
        y = rect.top / scale.value;
      }

      reviewTemplate.x = Math.round(x);
      reviewTemplate.y = Math.round(y);
    }

    /************************************************************
    * 出力済みテンプレート文言編集後イベント
    ************************************************************/

      const changeText = () => {
      const size = Common.getTextSize({text: state.currentReviewTemplate.text, fontSize: state.currentReviewTemplate.font_size, lineHeight: state.currentReviewTemplate.line_height, direction: state.currentReviewTemplate.direction});
      
      if(state.currentReviewTemplate.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.currentReviewTemplate.width;
        state.currentReviewTemplate.x -= diffW;
      }

      state.currentReviewTemplate.width = size.width;
      state.currentReviewTemplate.height = size.height;
      state.currentReviewTemplate.base64_text = Common.createBase64Text(state.currentReviewTemplate);
      state.currentReviewTemplate.is_edited = true;
    }

    /************************************************************
    * 出力済みテンプレートのフォントサイズ・行間変更後イベント
    ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.currentReviewTemplate.font_size = state.fontSize;
      state.currentReviewTemplate.line_height = state.lineHeight;
      state.currentReviewTemplate.color = state.textColor;
      const size = Common.getTextSize({text: state.currentReviewTemplate.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.currentReviewTemplate.direction});
      
      if(state.currentReviewTemplate.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.currentReviewTemplate.width;
        state.currentReviewTemplate.x -= diffW;
      }
      
      state.currentReviewTemplate.width = size.width;
      state.currentReviewTemplate.height = size.height;
      state.currentReviewTemplate.base64_text = Common.createBase64Text(state.currentReviewTemplate);
      state.currentReviewTemplate.is_edited = true;
    }

    /************************************************************
    * keydown
    ************************************************************/

      const keyDown = (e:KeyboardEvent) => {
      state.keyCode = e.key;
    }

    /************************************************************
    * keyup
    ************************************************************/

    const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";

      // input type="text" or input type="number" or textareaがフォーカスされている場合は処理しない
      if (document.activeElement instanceof HTMLTextAreaElement ||
        (document.activeElement instanceof HTMLInputElement && ["text", "number"].includes(document.activeElement.type))) {
        return;
      }

      e.preventDefault();

      if(e.key == "Backspace" && state.currentReviewTemplate != null){
        if(state.currentReviewTemplate.template_type == TemplateTypeEnum.Text){
          const idx = currentPageItem.value.autoReviewTextTemplates.indexOf(state.currentReviewTemplate);
          currentPageItem.value.autoReviewTextTemplates.splice(idx, 1);
        }else if(state.currentReviewTemplate.template_type == TemplateTypeEnum.Image){
          const idx = currentPageItem.value.autoReviewImageTemplates.indexOf(state.currentReviewTemplate);
          currentPageItem.value.autoReviewImageTemplates.splice(idx, 1);
        }
        state.currentReviewTemplate = null;
      }else if(["ArrowUp", "ArrowDown"].includes(e.key)){
        let currentReviewTemplate: AutoReviewTextTemplate = null;
        
        if(state.currentReviewTemplate){
          const idx = allReviewTemplates.value.indexOf(state.currentReviewTemplate);
          if(e.key == "ArrowUp"){
            if(idx > 0){
              currentReviewTemplate = allReviewTemplates.value[idx - 1];
            }else{
              currentReviewTemplate = allReviewTemplates.value[allReviewTemplates.value.length - 1];
            }
          }else if(e.key == "ArrowDown"){
            if(allReviewTemplates.value.length > idx + 1){
              currentReviewTemplate = allReviewTemplates.value[idx + 1];
            }else{
              currentReviewTemplate = allReviewTemplates.value[0];
            }
          }
        }else{
          if(e.key == "ArrowUp"){
            currentReviewTemplate = allReviewTemplates.value[allReviewTemplates.value.length - 1];
          }else if(e.key == "ArrowDown"){
            currentReviewTemplate = allReviewTemplates.value[0];
          }
        }

        changeCurrentReviewTemplate(currentReviewTemplate);
        context.root.$nextTick(async () => {
          if(currentReviewTemplate){
            await scrollImageArea(currentReviewTextElemId.value);
            scrollTableArea(`tr-${currentReviewTemplate.page}-${currentReviewTemplate.idx}`);
          }
          textEditBoxRef.value.moveTextEditbox();
        });
      }
    }

    /************************************************************
    * 更新
    ************************************************************/

    const update = async () => {
      state.errors = [];

      // 得点範囲の必須入力チェック
      allReviewTemplates.value.forEach((x, i) => {
        if(x.score_from === null || x.score_to === null){
          state.errors.push(`No${i + 1}の得点範囲が入力されていません。`);
        }
      });

      // エラー有の場合は処理終了
      if(state.errors.length > 0){
        return;
      }

      // 得点範囲の重複チェック(テキスト)
      if (findScoreRangeOverlappingTemplates(allReviewTextTemplates.value).length > 0) {
        state.errors.push(`得点範囲が重複している講評テキストが存在します。`);
      }

      // 得点範囲の重複チェック(画像)
      if (findScoreRangeOverlappingTemplates(allReviewImageTemplates.value).length > 0) {
        state.errors.push(`得点範囲が重複している講評画像が存在します。`);
      }

      // エラー有の場合は処理終了
      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("講評文を保存します。よろしいですか？")){
        return;
      }

      const paramReviewTextTemplates: ParamAutoReviewTextTemplate[] = [];
      allReviewTextTemplates.value.forEach(x => {
        // テキスト未入力 or サイズ検出不可のテンプレートはスキップ
        if(x.text == null || x.text.replace(/\r?\n/g, '').trim() == "" || x.width == 0 || x.height == 0){
          return;
        }
        paramReviewTextTemplates.push(new ParamAutoReviewTextTemplate(x));
      });

      const paramReviewImageTemplates: ParamAutoReviewImageTemplate[] = [];
      allReviewImageTemplates.value.forEach(x => {
        paramReviewImageTemplates.push(new ParamAutoReviewImageTemplate(x));
      });

      const param = {
        // 旧画面からの保存をバックエンド側で識別できるよう、画面形式のバージョンを送る
        template_format_version: 2,
        auto_review_text_templates: paramReviewTextTemplates,
        auto_review_image_templates: paramReviewImageTemplates,
      }

      context.root.$store.dispatch("showOverlay");

      await http.patch(`/api/teacher/auto_review_template_edit/${state.base_sheet_id}`, param).then(response => {
        alert("処理が完了しました。");
        if(context.root.$store.getters.isOptionMovieActive){
          context.root.$router.push(`/teacher_site/movie_content_upload/${state.base_sheet_id}`).catch(err => {});
        }else{
          context.root.$store.dispatch("goBaseSheetList");
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
    * 得点範囲の重複判定
    ************************************************************/

    const isScoreRangeOverlapping = (range1: AutoReviewTextTemplate, range2: AutoReviewTextTemplate): boolean => {
      const from1 = typeof range1.score_from === 'string' ? parseFloat(range1.score_from) : range1.score_from;
      const to1 = typeof range1.score_to === 'string' ? parseFloat(range1.score_to) : range1.score_to;
      const from2 = typeof range2.score_from === 'string' ? parseFloat(range2.score_from) : range2.score_from;
      const to2 = typeof range2.score_to === 'string' ? parseFloat(range2.score_to) : range2.score_to;

      if (from1 === null || to1 === null || from2 === null || to2 === null) {
        return false;
      }

      return (from1 <= to2 && to1 >= from2);
    }

    /************************************************************
    * 得点範囲が重複している講評テンプレート検出
    ************************************************************/

    const findScoreRangeOverlappingTemplates = (ranges: AutoReviewTextTemplate[]): [AutoReviewTextTemplate, AutoReviewTextTemplate][] => {
      const overlappingTemplates: [AutoReviewTextTemplate, AutoReviewTextTemplate][] = [];

      for (let i = 0; i < ranges.length; i++) {
        for (let j = i + 1; j < ranges.length; j++) {
          // 同一対象種別・同一大問内だけを重複判定対象とする
          if (ranges[i].target_type == ranges[j].target_type && ranges[i].part1 == ranges[j].part1 && isScoreRangeOverlapping(ranges[i], ranges[j])) {
            overlappingTemplates.push([ranges[i], ranges[j]]);
          }
        }
      }

      return overlappingTemplates;
    }

    /******************************
    * 検索条件クリア
    ******************************/

      const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
    * 検索ボタン押下
    ******************************/

      const searchClick = () => {
      state.condition.currentPage = 1;
      search();
    };

    /******************************
    * 検索API
    ******************************/

      const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/auto_review_template_edit/search_base_sheets/${state.base_sheet_id}?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheets.map((x: any) => new BaseSheet(x)); 
        context.root.$store.commit("setAutoReviewTemplateEditCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
    * 講評テンプレートコピー
    ******************************/

    const copyTemplate = async (base_sheet_id: number) => {

      if(!window.confirm("講評文のコピーを実行します。現在出力されている講評は削除されます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.get(`/api/teacher/auto_review_template_edit/search_review_template/${base_sheet_id}`).then(response => {
        state.pageItems.forEach(x => x.setAutoReviewTextTemplates = response.data.auto_review_text_templates);
        state.pageItems.forEach(x => x.setAutoReviewImageTemplates = response.data.auto_review_image_templates);

        state.pageItems.forEach(pageItem => {
          pageItem.autoReviewTextTemplates.forEach(autoReviewTextTemplate => {
            const rect: any = {
              left: autoReviewTextTemplate.x * scale.value,
              top: autoReviewTextTemplate.y * scale.value,
              width: autoReviewTextTemplate.width * scale.value,
              height: autoReviewTextTemplate.height * scale.value,
            }
            setReviewTemplatePosition(autoReviewTextTemplate, rect);
          });
          pageItem.autoReviewImageTemplates.forEach(autoReviewImageTemplate => {
            const rect: any = {
              left: autoReviewImageTemplate.x * scale.value,
              top: autoReviewImageTemplate.y * scale.value,
              width: autoReviewImageTemplate.width * scale.value,
              height: autoReviewImageTemplate.height * scale.value,
            }
            setReviewTemplatePosition(autoReviewImageTemplate, rect);
          });
        });

        modalBaseSheetListRef.value.hide();
        Common.showToast(context.root.$bvToast, "講評をコピーしました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /****************************************
    * マーク一覧の全件チェックボックス監視
    ****************************************/

    watch(() => state.isAllSelectChecked, (newVal, oldVal) => {
      allReviewTemplates.value.forEach(x => x.is_disp = newVal);
    });

    /************************************************************
    * onMounted
    ************************************************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/auto_review_template_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        context.root.$store.commit("setScoringSettingSheetType", response.data.base_sheet.sheet_type);
        state.baseSheet = response.data.base_sheet;
        state.part1Options = response.data.part1_options.map((x: string) => new Part1Option(x));
        state.autoReviewImageBookmarks= response.data.auto_review_image_bookmarks.map((x: any) => new AutoReviewImageBookmark(x));
        response.data.base64_images.forEach((base64Image: string, i: number) => {
          state.pageItems.push(new PageItem(i + 1, base64Image, response.data.image_size_hashes[i], response.data.auto_review_text_templates, response.data.auto_review_image_templates));
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keydown", keyDown);
      window.addEventListener("keyup", keyUp);

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
    * Before Unmount
    ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      textEditBoxRef,
      modalBaseSheetListRef,
      modalImageBookmarkRef,
      TemplateTypeEnum,
      AutoReviewTargetTypeEnum,
      scale,
      parentW,
      parentH,
      imageWrapStyle,
      currentPageItem,
      currentReviewTextElemId,
      allReviewTemplates,
      reviewTargetOptions,
      getReviewTargetValue,
      changeReviewTarget,
      adjustHeight,
      addReviewTextTemplate,
      deleteReviewTextTemplate,
      deleteReviewImageTemplate,
      addReviewImageTemplate,
      addReviewImageBookmark,
      deleteReviewImageBookmark,
      trClick,
      changeText,
      textFormatChanged,
      changeCurrentReviewTemplate,
      update,
      clearCondition,
      searchClick,
      copyTemplate,
      imageAreaTouchstart,
      imageAreaTouchend,
      imageAreaTouchmove,
      imageAreaMousewheel,
    };
  }
})
